var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { encountersService } from 'ziphy-web-shared/basic/api';
import { needToFinishEncountersManually, } from 'ziphy-web-shared/basic/entities/appointments';
import { getEncounterStatus } from 'ziphy-web-shared/basic/entities/encounters';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import { $loader } from 'ziphy-web-shared/basic/utils';
import { confirmAction } from '@library/utils/actionConfirmator/ActionConfirmator';
import { $appts } from '@store';
const loaderHandlers = {
    start: 'start-encounter',
    cancel: 'cancel-encounter',
    finish: 'finish-encounter',
    restart: 'restart-encounter',
};
const EncounterButtons = ({ encounter, appointment, isStartProvider, doneButtonClassName, doneButtonMode = ['primary', 'sm'], cancelButtonClassName, cancelButtonMode = [$windowSize.isMobile ? 'secondary' : 'white-dark', 'sm'], }) => {
    const { t } = useTranslation();
    const handleStartEncounter = $loader.registerHandler(loaderHandlers.start, () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield encountersService.start({ id: encounter.id });
        if (!response.error)
            yield $appts.getOne({ id: appointment.id });
    }));
    const handleCancelEncounter = $loader.registerHandler(loaderHandlers.cancel, (e) => __awaiter(void 0, void 0, void 0, function* () {
        confirmAction('customAlert', {
            data: {
                title: t('appt_confirmator.cancel_encounter.title'),
                message: t('appt_confirmator.cancel_encounter.message'),
            },
            callback: () => __awaiter(void 0, void 0, void 0, function* () {
                const response = yield encountersService.cancel({ id: encounter.id });
                if (!response.error)
                    yield $appts.getOne({ id: appointment.id });
            }),
        }, e);
    }));
    const handleFinishEncounter = $loader.registerHandler(loaderHandlers.finish, () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield encountersService.finish({ id: encounter.id });
        if (!response.error)
            yield $appts.getOne({ id: appointment.id });
    }));
    const handleRestartEncounter = $loader.registerHandler(loaderHandlers.restart, () => __awaiter(void 0, void 0, void 0, function* () {
        yield encountersService.create({
            appointmentId: appointment.id,
            patientId: encounter.patientId,
        });
        const response = yield encountersService.start({ id: encounter.id });
        if (!response.error)
            yield $appts.getOne({ id: appointment.id });
    }));
    const { canStart, canRestart, canFinish, canCancel } = getEncounterStatus(encounter);
    const canControl = needToFinishEncountersManually(appointment) &&
        isStartProvider &&
        appointment.status === 'started';
    if (!canControl) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(_Fragment, { children: [canStart && (_jsx(Button, Object.assign({ mode: doneButtonMode, onClick: handleStartEncounter, className: doneButtonClassName, isLoading: $loader.isRunHandler(loaderHandlers.start) }, { children: t('btn.start_encounter') }))), canRestart && (_jsx(Button, Object.assign({ mode: doneButtonMode, onClick: handleRestartEncounter, className: doneButtonClassName, isLoading: $loader.isRunHandler(loaderHandlers.restart) }, { children: t('btn.restart_encounter') }))), canFinish && (_jsx(Button, Object.assign({ mode: doneButtonMode, onClick: handleFinishEncounter, className: doneButtonClassName, isLoading: $loader.isRunHandler(loaderHandlers.finish) }, { children: t('btn.complete_encounter') }))), canCancel && (_jsx(Button, Object.assign({ mode: cancelButtonMode, onClick: handleCancelEncounter, className: cancelButtonClassName, isLoading: $loader.isRunHandler(loaderHandlers.cancel) }, { children: t('btn.cancel') })))] }));
};
export default observer(EncounterButtons);
